import logo from "./logo.svg";
import "./App.css";
import Form from "./components/form";
function App() {
  return (
    <div className="App">
      <div className="App">
        <div className="container">
          <div className="card">
            <Form />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
